import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from '@/hooks/useTranslation';

export const Route = createFileRoute('/p/')({
  component: PartnerHomePage,
});

function PartnerHomePage() {
  const { t } = useTranslation();
  return (
    <div style={{ padding: '32px' }}>
      <h1>{t('K_PARTNER_PORTAL', 'Partner Portal')}</h1>
      <p>{t('K_PARTNER_SPECIFIC_CONTENT', 'Partner-specific content will go here.')}</p>
    </div>
  );
}
